import { FC, ReactNode } from 'react';

import styles from './MortgageTitle.module.scss';

interface DocumentTitleProps {
  children: ReactNode;
}

const MortgageTitle: FC<DocumentTitleProps> = ({ children }) => {
  return <div className={styles.titleBox}>{children}</div>;
};

export default MortgageTitle;
